import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import * as calendarioActions from '../../reducers/CalendarioReducer/actions'
import { calendarioPickupSelector, calendarioDeliverySelector } from '../../selectors/calendarioSelector'
import { usuarioSelector, instalacionSelector } from '../../selectors/sessionSelector'
import { sucursalesSelector } from '../../selectors/sucursalesSelector'
import Calendario from '../../components/Calendario'
import PropTypes from 'prop-types';
class CalendarioContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sucursalesPickup: [],
      sucursalPickupSeleccionada: undefined
    };
  }

  componentDidMount() {
    this.getCalendario(1); // pickup
    this.getCalendario(2); // delivery
  }

  componentDidUpdate(prevProps) {
    // Verifica si las sucursales han cambiado antes de actualizar el estado
    if (prevProps.sucursales !== this.props.sucursales) {
      this.initializeSucursalesPickup();
    }
  }

  initializeSucursalesPickup() {
    const { sucursales, usuario } = this.props;
    const sucursalesPickup = sucursales
      .filter(sucursal => sucursal.formasDeEntrega.find(x => x.idFormaEntrega === 1))
      .map(sucursal => ({
        idSucursal: sucursal.idSucursal,
        nombre: sucursal.nombre,
        direccion: sucursal.direccion,
        porDefecto: sucursal.formasDeEntrega.find(x => x.idFormaEntrega === 1).porDefecto
      }));

    const sucursalPickupSeleccionada = usuario.ultimaSucursalPickup || (sucursalesPickup.find(x => x.porDefecto === true) || {}).idSucursal;

    this.setState({
      sucursalesPickup,
      sucursalPickupSeleccionada
    });
  }

  getCalendario = (idTipoCalendario) => {
    const { instalacion, usuario, sagaFetchCalendario } = this.props;
    console.log('props getCalendario', this.props);
    const sucursales = this.state.sucursalesPickup.length > 0 ? this.state.sucursalesPickup : this.props.sucursales;
    const sucursalPorDefecto = sucursales.find(sucursal =>
        sucursal.formasDeEntrega && sucursal.formasDeEntrega.some(fe => fe.porDefecto === true)
      );
  const idSucursalDefecto = sucursalPorDefecto && sucursalPorDefecto.idSucursal;
    let id;
    switch (idTipoCalendario) {
      case 1:
        // id = usuario.ultimaSucursalPickup || (sucursales.find(x => x.porDefecto === true) || {}).idSucursal;
        id = usuario.ultimaSucursalPickup || idSucursalDefecto;

        break;

      case 2:
        // id = usuario.ultimaSucursalDelivery || (sucursales.find(x => x.porDefecto === true) || {}).idSucursal;
        id = usuario.ultimaSucursalDelivery || idSucursalDefecto;
        break;

      default:
        break;
    }
    console.log('== DEBUG getCalendario ==');
    console.log('idTipoCalendario:', idTipoCalendario);
    console.log('usuario.ultimaSucursalPickup:', usuario.ultimaSucursalPickup);
    console.log('usuario.ultimaSucursalDelivery:', usuario.ultimaSucursalDelivery);
    console.log('sucursales:', sucursales);
    console.log('instalacion.id:', instalacion && instalacion.id);
    console.log('idSucursalDefecto:', idSucursalDefecto);
    console.log('id seteado (sucursal):', id);

    const payload = {
      idTipoCalendario,
      idInstalacion: id || instalacion.id,
      idRecurso: id || 1
    };
    console.log('payload en CalendarioContainer', payload);

    sagaFetchCalendario(payload);
  };

  handleOnChangeSucursalPickup = (idSucursal) => {
    this.setState({ sucursalPickupSeleccionada: idSucursal });
    const payload = {
      idTipoCalendario: 1,
      idInstalacion: idSucursal,
      idRecurso: idSucursal || 1
    };

    this.props.sagaFetchCalendario(payload);
  };

  render() {
    return (
      <Calendario
        calendarioPickup={this.props.calendarioPickup}
        calendarioDelivery={this.props.calendarioDelivery}
        handleOnClose={this.props.handleOnClose}
        sucursalesPickup={this.state.sucursalesPickup}
        sucursalPickupSeleccionada={this.state.sucursalPickupSeleccionada}
        handleOnChangeSucursalPickup={(e) => this.handleOnChangeSucursalPickup(e.target.value)}
      />
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    ...calendarioActions,
  }, dispatch);
}

function mapStateToProps(state) {
  return {
    instalacion: instalacionSelector(state),
    calendarioPickup: calendarioPickupSelector(state),
    calendarioDelivery: calendarioDeliverySelector(state),
    usuario: usuarioSelector(state),
    sucursales: sucursalesSelector(state)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CalendarioContainer);
